import { FetchError } from '@sierralabs/react-material-ui';
import { useCallback, useEffect, useState } from 'react';
import environment from '../../environments';

export function useRecaptchaEnterprise() {
  const [loadingRecaptchaToken, setLoadingRecaptchaToken] = useState(false);
  const [loadingRecaptchaTokenError, setLoadingRecaptchaTokenError] =
    useState<FetchError>();
  useEffect(() => {
    if (environment?.recaptchaSiteKey && !window.grecaptcha) {
      console.log('loading recaptcha script');
      const script = document.createElement('script');
      script.src = `//www.google.com/recaptcha/enterprise.js?render=${environment.recaptchaSiteKey}`;
      script.async = true;
      document.body.appendChild(script);
      return () => {
        console.log('removing recaptcha script');
        document.body.removeChild(script);
      };
    }
  }, []);

  const getRecaptchaToken = useCallback((action: string) => {
    return new Promise<string>((resolve, reject) => {
      setLoadingRecaptchaToken(true);
      setLoadingRecaptchaTokenError(undefined);
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(environment.recaptchaSiteKey || '', { action })
          .then(
            (token: string) => {
              setLoadingRecaptchaToken(false);
              resolve(token);
            },
            error => {
              setLoadingRecaptchaToken(false);
              setLoadingRecaptchaTokenError(error);
              reject(error);
            }
          );
      });
    });
  }, []);

  return {
    loadingRecaptchaToken,
    loadingRecaptchaTokenError,
    getRecaptchaToken
  };
}
